import React from 'react';
import { ChevronLeft, ChevronRight, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';

// Ordered container sequence — update this list as new containers are built
export const CONTAINERS = [
  { id: 'overview', title: 'API Overview', link: '/technical-documentation/api-reference/overview', built: true },
  { id: 'sale-pre-auth', title: 'Sale & Pre-Auth', link: '/technical-documentation/api-reference/sale-pre-auth', built: true },
  { id: '3d-secure-auth', title: '3D Secure Auth', link: '/technical-documentation/api-reference/3d-secure-auth', built: true },
  { id: '3d-secure-confirm', title: '3D Secure Confirm', link: '/technical-documentation/api-reference/3d-secure-confirm', built: true },
  { id: 'complete-pre-auth', title: 'Complete Pre-Auth', link: '/technical-documentation/api-reference/complete-pre-auth', built: true },
  { id: 'void-pre-auth', title: 'Void Pre-Auth', link: '/technical-documentation/api-reference/void-pre-auth', built: true },
  { id: 'refund', title: 'Refund', link: '/technical-documentation/api-reference/refund', built: true },
  { id: 'recurring-billing', title: 'Recurring Billing', link: '/technical-documentation/api-reference/recurring-billing', built: true },
  { id: 'hosted-payment-page', title: 'Hosted Payment Page', link: '/technical-documentation/api-reference/hosted-payment-page', built: true },
  { id: 'hosted-payment-token', title: 'Hosted Payment Token', link: '/technical-documentation/api-reference/hosted-payment-token', built: true },
  { id: 'dcc', title: 'DCC', link: '/technical-documentation/api-reference/dcc', built: true },
  { id: 'google-pay', title: 'Google Pay', link: '/technical-documentation/api-reference/google-pay', built: true },
];

const ContainerPagination = ({ currentId }) => {
  const idx = CONTAINERS.findIndex((c) => c.id === currentId);
  if (idx === -1) return null;

  const prev = idx > 0 ? CONTAINERS[idx - 1] : null;
  const next = idx < CONTAINERS.length - 1 ? CONTAINERS[idx + 1] : null;

  const Card = ({ item, side }) => {
    if (!item) return <div className="flex-1" />;

    const isPrev = side === 'prev';
    const base = 'group flex-1 flex items-center gap-4 p-4 rounded-lg border shadow-sm transition-all duration-200';
    const active = 'border-[#1F4E79]/20 bg-white hover:border-[#1F4E79] hover:shadow-md hover:-translate-y-0.5';
    const disabled = 'border-gray-200 bg-gray-50/60 cursor-not-allowed opacity-60';

    const labelEl = (
      <div className={`flex-1 min-w-0 ${isPrev ? 'text-left' : 'text-right'}`}>
        <div className="flex items-center gap-2 text-xs font-semibold text-gray-500 uppercase tracking-wide mb-0.5" style={{ justifyContent: isPrev ? 'flex-start' : 'flex-end' }}>
          {isPrev ? <>Previous</> : <>Next</>}
          {!item.built && (
            <span className="inline-flex items-center gap-1 px-1.5 py-0.5 bg-amber-100 text-amber-800 rounded text-[10px] font-bold">
              <Clock size={9} />
              Soon
            </span>
          )}
        </div>
        <div className={`text-base font-bold truncate ${item.built ? 'text-[#1F4E79] group-hover:text-[#163a5f]' : 'text-gray-500'}`}>
          {item.title}
        </div>
      </div>
    );

    if (!item.built) {
      return (
        <div className={`${base} ${disabled}`} data-testid={`pagination-${side}-disabled`}>
          {isPrev && <ChevronLeft size={28} className="text-gray-300 flex-shrink-0" />}
          {labelEl}
          {!isPrev && <ChevronRight size={28} className="text-gray-300 flex-shrink-0" />}
        </div>
      );
    }

    return (
      <Link
        to={item.link}
        className={`${base} ${active}`}
        data-testid={`pagination-${side}`}
      >
        {isPrev && <ChevronLeft size={28} className="text-[#1F4E79] flex-shrink-0 group-hover:-translate-x-0.5 transition-transform" />}
        {labelEl}
        {!isPrev && <ChevronRight size={28} className="text-[#1F4E79] flex-shrink-0 group-hover:translate-x-0.5 transition-transform" />}
      </Link>
    );
  };

  return (
    <nav
      className="mt-8 mb-2 flex flex-col sm:flex-row gap-3 bg-white/80 backdrop-blur-sm rounded-lg shadow-lg p-4"
      aria-label="Container navigation"
      data-testid="container-pagination"
    >
      <Card item={prev} side="prev" />
      <Card item={next} side="next" />
    </nav>
  );
};

export default ContainerPagination;
